module.exports = __webpack_public_path__ + "img/钟表-7.6f9caca4.png";